import { Dialog } from "@mui/material"
import { DialogActionsBar } from "@progress/kendo-react-dialogs"
import { UserPermissionName } from "../../models/user-permission-name";
import { useAuthorize } from "../../hooks/use-authorize";

interface ReadyConfirmationDialog {
    onSubmit: () => void;
    onClosed: () => void;
}


export const ReadyConfirmationDialog = ({ onSubmit, onClosed }: ReadyConfirmationDialog) => {
    const ishavePermission = useAuthorize([UserPermissionName?.OVERRIDE]);
    const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);
    return (
        <Dialog
            open={true}
            className="modalpopup"
            title='CONFIRM READY STATUS'
            maxWidth={'md'}
        // onClose={closeDialog}
        >
            <div>
                <div style={{ padding: '25px 50px' }}>
                    <div>
                        {ishavePermission
                            ?
                            <>
                                You have the permission to change the status without completing the prerequisite service.
                                <br />
                                Are you sure you want to continue?
                            </>
                            : <>You can not change the status to ready as pre-requisite service is not yet completed.</>}
                    </div>
                </div>
            </div>
            <DialogActionsBar>
                <div className=" spaceBetween">
                    <button
                        style={{ cursor: 'pointer' }}
                        className="btn btn-sm btn-default btn-lightGrey"
                        onClick={onClosed}
                        autoFocus
                    >
                        Cancel
                    </button>
                    {ishavePermission && (
                        <button
                            className="btn btn-sm btn-primary  btn-delete"
                            style={{
                                backgroundColor: isReadOnlyPermission ? '#d7dbdd' : '#0000b5',
                                color: isReadOnlyPermission ? 'black' : '#fff',
                                cursor: 'pointer'
                            }}
                            type="button"
                            onClick={onSubmit}
                            disabled={isReadOnlyPermission}
                        >
                            Confirm
                        </button>
                    )}
                </div>
            </DialogActionsBar>
        </Dialog>
    )
}